import { render, staticRenderFns } from "./shipment_add.vue?vue&type=template&id=47b528e6&scoped=true"
import script from "./shipment_add.vue?vue&type=script&lang=js"
export * from "./shipment_add.vue?vue&type=script&lang=js"
import style0 from "./shipment_add.vue?vue&type=style&index=0&id=47b528e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b528e6",
  null
  
)

export default component.exports